module.exports = __webpack_public_path__ + "img/learning-time.8c074e00.png";